import { BookOpen, Brain, Layers, Pencil, Download, Shield } from 'lucide-react';

const features = [
  {
    icon: BookOpen,
    title: 'NCERT/CBSE Ready',
    description:
      'Generate questions aligned to the NCERT curriculum used by CBSE classrooms across India.',
    color: 'bg-teal-50 text-teal-600',
  },
  {
    icon: Brain,
    title: 'AI-Powered Engine',
    description:
      'Create pedagogically sound questions with plausible distractors, answer keys, and explanations.',
    color: 'bg-blue-50 text-blue-600',
  },
  {
    icon: Layers,
    title: "Bloom's Taxonomy",
    description:
      'Choose the cognitive level from Remembering to Creating so every paper has visible rigor.',
    color: 'bg-amber-50 text-amber-600',
  },
  {
    icon: Shield,
    title: '6 Question Types',
    description:
      'MCQ, Multiple Select, True/False, Fill in the Blanks, Inline Choice, and Matching.',
    color: 'bg-emerald-50 text-emerald-600',
  },
  {
    icon: Pencil,
    title: 'Edit & Customize',
    description:
      'Modify generated questions inline, adjust options, update explanations and difficulty.',
    color: 'bg-rose-50 text-rose-600',
  },
  {
    icon: Download,
    title: 'Bundle & Export',
    description:
      'Group questions into timed assessments with point values and export as JSON.',
    color: 'bg-cyan-50 text-cyan-600',
  },
];

export default function FeaturesGrid() {
  return (
    <section id="features" className="py-20 sm:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
            Built for Faster, Better
            <br />
            <span className="text-teal-600">NCERT Assessments</span>
          </h2>
          <p className="text-lg text-slate-500 mt-4">
            A focused toolkit for Indian educators who need structured,
            curriculum-aligned questions without monthly software commitments.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="bg-white rounded-2xl border border-slate-200 p-6 hover:shadow-lg hover:shadow-slate-200/50 hover:-translate-y-1 transition-all duration-300 group"
            >
              <div
                className={`w-12 h-12 rounded-xl flex items-center justify-center ${feature.color} mb-4 group-hover:scale-110 transition-transform duration-300`}
              >
                <feature.icon className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-slate-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
